import { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import EventTracker from "../../utils/Tracker/EventTracker";
import filterPayload from "../../utils/Tracker/filterPayload";
import TrackerContext from "./context";
import { jsx as _jsx } from "react/jsx-runtime";
let globalState = {
  getConfig: null,
  source: null
};
export const trackEvent = function () {
  let eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown Event';
  let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let defaultData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const {
    getConfig,
    source
  } = globalState;
  const verifiedPayload = payload !== null ? payload : {};
  if (!eventName || !verifiedPayload || !defaultData || !getConfig) {
    const msg = 'trackEvent missing arguments';
    if (typeof window !== 'undefined' && window.Rollbar) {
      window.Rollbar.error(msg, {
        eventName,
        payload: verifiedPayload
      });
    }
    // eslint-disable-next-line no-console
    return console.error(msg);
  }
  const filteredPayload = filterPayload({
    source,
    payload: verifiedPayload,
    defaultData
  });
  return EventTracker.trackClick(eventName, filteredPayload, {
    ...getConfig(),
    ...config
  });
};
const setGlobalState = (getConfig, source) => {
  globalState = {
    getConfig,
    source
  };
};
const Tracker = _ref => {
  let {
    children,
    getConfig,
    source,
    className = '',
    style = {}
  } = _ref;
  useEffect(() => {
    setGlobalState(getConfig, source);
  }, [getConfig, source]);
  const eventTracker = useCallback(function () {
    let eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown Event';
    let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let defaultData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    setGlobalState(getConfig, source);
    trackEvent(eventName, payload, defaultData);
  }, [getConfig, source]);
  return /*#__PURE__*/_jsx("div", {
    className: className,
    style: style,
    children: /*#__PURE__*/_jsx(TrackerContext.Provider, {
      value: eventTracker,
      children: children
    })
  });
};
Tracker.propTypes = {
  /** Children components to be wrapped by Tracker */
  children: PropTypes.node.isRequired,
  /** Source identifier for the event tracker */
  source: PropTypes.string.isRequired,
  /** Function to get configuration settings */
  getConfig: PropTypes.func.isRequired,
  /** Optional class name for styling */
  className: PropTypes.string,
  /** Inline styles for the root element */
  style: PropTypes.object
};
export default Tracker;
//# sourceMappingURL=Tracker.js.map